export const CUSTOM_TRANSLATIONS = [
  {
    key: 'contracts.contract_picker_l',
    value: 'resident_shared.account.contract_l',
  },
  {
    key: 'registration.success_l',
    value: 'resident_shared.registration_success_l',
  },
  {
    key: 'registration.failed_l',
    value: 'resident_shared.registration_failed_l',
  },
  {
    key: 'check_contract_partner_numbers_success_l',
    value: 'resident_shared.check_contract_partner_numbers_success_l',
  },
  {
    key: 'check_contract_partner_numbers_failed_l',
    value: 'resident_shared.check_contract_partner_numbers_failed_l',
  },
  {
    key: 'registration.resend_confirm_email_success_m',
    value: 'resident_shared.registration.resend_confirm_email_success_m',
  },
  {
    key: 'registration.resend_confirm_email_error_m',
    value: 'resident_shared.registration.resend_confirm_email_error_m',
  },
  {
    key: 'registration.confirmation_success_l',
    value: 'resident_shared.registration.confirmation_success_l',
  },
  {
    key: 'registration.confirmation_error_l',
    value: 'resident_shared.registration.confirmation_error_l',
  },
  {
    key: 'authentication.init_reset_password_error_m',
    value: 'resident_shared.authentication.init_reset_password_error_m',
  },
  {
    key: 'authentication.init_reset_password_success_m',
    value: 'resident_shared.authentication.init_reset_password_success_m',
  },
  {
    key: 'user_profile.change_password_success_m',
    value: 'resident_shared.user_profile.change_password_success_m',
  },
  {
    key: 'user_profile.change_password_error_m',
    value: 'resident_shared.user_profile.change_password_error_m',
  },
  {
    key: 'user-profile.name',
    value: 'resident_shared.user-profile.name',
  },
  {
    key: 'user-profile.address',
    value: 'resident_shared.user-profile.address',
  },
  {
    key: 'mobile_phone',
    value: 'resident_shared.mobile_phone',
  },
  {
    key: 'phone',
    value: 'resident_shared.phone',
  },
  {
    key: 'general.email',
    value: 'resident_shared.general.email',
  },
  {
    key: 'general.ok',
    value: 'resident_shared.general.ok',
  },
  {
    key: 'general.save_changes',
    value: 'resident_shared.general.save_changes',
  },
  {
    key: 'general.log_in_now',
    value: 'resident_shared.general.log_in_now',
  },
  {
    key: 'general.password',
    value: 'resident_shared.general.password',
  },
  {
    key: 'sign_in_header',
    value: 'resident_shared.sign_in_header',
  },
  { key: 'navigation.collapse_sidebar_a', value: 'resident_shared.navigation.collapse_sidebar_a' },
  { key: 'navigation.expand_sidebar_a', value: 'resident_shared.navigation.expand_sidebar_a' },
  { key: 'settings.delete_account', value: 'resident_shared.settings.delete_account' },
  {
    key: 'pw-check.error.pw-has_number_special',
    value: 'resident_shared.pw-check.error.pw-has_number_special',
  },
  {
    key: 'pw-check.error.pw-has_lower_upper_case',
    value: 'resident_shared.pw-check.error.pw-has_lower_upper_case',
  },
  {
    key: 'pw-check.error.pw-min_length',
    value: 'resident_shared.pw-check.error.pw-min_length',
  },
  {
    key: 'pw_reset_form.current_pw',
    value: 'resident_shared.pw_reset_form.current_pw',
  },
  {
    key: 'pw-check.title_rs_l',
    value: 'resident_shared.pw-check.title_rs_l',
  },
  {
    key: 'pw_reset_form.pw',
    value: 'resident_shared.pw_reset_form.pw',
  },
  {
    key: 'pw_reset_form.pw_confirm',
    value: 'resident_shared.pw_reset_form.pw_confirm',
  },
  {
    key: 'user_delete.urgent_notice',
    value: 'resident_shared.user_delete.urgent_notice',
  },
  {
    key: 'user_delete.title',
    value: 'resident_shared.user_delete.title',
  },
  {
    key: 'user_delete.body',
    value: 'resident_shared.user_delete.body',
  },
  {
    key: 'user_delete.confirm',
    value: 'resident_shared.user_delete.confirm',
  },
  {
    key: 'user_delete.confirmation_input_l',
    value: 'resident_shared.user_delete.confirmation_input_l',
  },
  {
    key: 'user_delete.confirmation_input_hint',
    value: 'resident_shared.user.lastname',
  },
  {
    key: 'update_masterdata.success_m',
    value: 'resident_shared.update_masterdata.success_m',
  },
  {
    key: 'update_masterdata.error_m',
    value: 'resident_shared.update_masterdata.error_m',
  },
  {
    key: 'pw_reset_form.change_pw',
    value: 'resident_shared.pw_reset_form.change_pw',
  },
  {
    key: 'pw-check.title_l',
    value: 'resident_shared.pw-check.title_l',
  },
  {
    key: 'main_navigation.legal-info_l',
    value: 'resident_shared.main_navigation.legal-info_l',
  },
  {
    key: 'main_navigation.user_faq_l',
    value: 'resident_shared.main_navigation.user_faq_l',
  },
  {
    key: 'main_navigation.dashboard_l',
    value: 'resident_shared.main_navigation.dashboard_l',
  },
  {
    key: 'main_navigation.contracts_l',
    value: 'resident_shared.main_navigation.contracts_l',
  },
  {
    key: 'main_navigation.contract_l',
    value: 'resident_shared.main_navigation.contract_l',
  },
  {
    key: 'legal.agb',
    value: 'resident_shared.legal.agb',
  },
  {
    key: 'legal.accessibility_statement',
    value: 'resident_shared.legal.accessibility_statement',
  },
  {
    key: 'legal.accessibility_statement_short',
    value: 'resident_shared.legal.accessibility_statement_short',
  },
  {
    key: 'legal.privacy_policy',
    value: 'resident_shared.legal.privacy_policy',
  },
  {
    key: 'legal.terms_of_use',
    value: 'resident_shared.legal.terms_of_use',
  },
  {
    key: 'legal.impress',
    value: 'resident_shared.legal.impress',
  },
  {
    key: 'faq.header_title',
    value: 'resident_shared.faq.header_title',
  },
  {
    key: 'user.settings',
    value: 'resident_shared.user.settings',
  },
  {
    key: 'user.more_information',
    value: 'resident_shared.user.more_information',
  },
  {
    key: 'user.personal_data',
    value: 'resident_shared.user.personal_data',
  },
  {
    key: 'user.notifications',
    value: 'resident_shared.user.notifications',
  },
  {
    key: 'user.privacy',
    value: 'resident_shared.user.privacy',
  },
  {
    key: 'user.delete_account',
    value: 'resident_shared.user.delete_account',
  },
  {
    key: 'user.legal_info',
    value: 'resident_shared.user.legal_info',
  },
  {
    key: 'user.faq',
    value: 'resident_shared.user.faq',
  },
  {
    key: 'faq.read_more',
    value: 'resident_shared.faq.read_more',
  },
  {
    key: 'contracts.overview_header',
    value: 'resident_shared.contracts.overview_header',
  },
  {
    key: 'contract.agents.header',
    value: 'resident_shared.contract.agents.header',
  },
  {
    key: 'contract.type.flat',
    value: 'resident_shared.contract.type.flat',
  },
  {
    key: 'contract.payment.type.rent',
    value: 'resident_shared.contract.payment.type.rent',
  },
  {
    key: 'contract.payment.type.others',
    value: 'resident_shared.contract.payment.type.others',
  },
  {
    key: 'contract.payment.type.heating_prepayment',
    value: 'resident_shared.contract.payment.type.heating_prepayment',
  },
  {
    key: 'contract.payment.type.service_payment',
    value: 'resident_shared.contract.payment.type.service_payment',
  },
  {
    key: 'hierarchical_questions.answer_boolean.option_yes_l',
    value: 'hierarchical_questions.answer_boolean.option_yes_l',
  },
  {
    key: 'hierarchical_questions.answer_boolean.option_no_l',
    value: 'hierarchical_questions.answer_boolean.option_no_l',
  },
  {
    key: 'general.offline',
    value: 'resident_shared.general.offline',
  },
  {
    key: 'hierarchical_questions.answer_boolean.option_yes_l',
    value: 'hierarchical_questions.answer_boolean.option_yes_l',
  },
  {
    key: 'hierarchical_questions.answer_boolean.option_no_l',
    value: 'hierarchical_questions.answer_boolean.option_no_l',
  },
  {
    key: 'ticket_details_description.show_less',
    value: 'resident_shared.less',
  },
  {
    key: 'ticket_details_description.description',
    value: 'resident_wankendorfer.demage.description',
  },
  {
    key: 'ticket_details.yes_confirmation',
    value: 'hierarchical_questions.answer_boolean.option_yes_l',
  },
  {
    key: 'ticket_details.no_confirmation',
    value: 'hierarchical_questions.answer_boolean.option_no_l',
  },
  {
    key: 'service.on_document_download_fail_l',
    value: 'resident_shared.service.on_document_download_fail_l',
  },
  {
    key: 'contract.documents.overview_header',
    value: 'resident_shared.contract.documents.overview_header',
  },
  {
    key: 'contract.sepa.issued_at.prefix',
    value: 'resident_shared.contract.sepa.issued_at.prefix',
  },
  {
    key: 'contract.sepa.issued_at.suffix',
    value: 'resident_shared.contract.sepa.issued_at.suffix',
  },
  {
    key: 'contract.sepa.issued_at.suffix',
    value: 'resident_shared.contract.sepa.issued_at.suffix',
  },
  {
    key: 'contract.payment.chart.header',
    value: 'resident_shared.contract.payment.chart.header',
  },
  {
    key: 'contract.payment.chart.total',
    value: 'resident_shared.contract.payment.chart.total',
  },
  {
    key: 'document.type.requested_document',
    value: 'resident_shared.document.type.requested_document',
  },
  {
    key: 'document.type.rental_contract',
    value: 'resident_shared.document.type.rental_contract',
  },
  {
    key: 'document.type.rental_contract_flat',
    value: 'resident_shared.document.type.rental_contract_flat',
  },
  {
    key: 'document.type.rental_contract_garage',
    value: 'resident_shared.document.type.rental_contract_garage',
  },
  {
    key: 'document.type.rental_contract_commercial',
    value: 'resident_shared.document.type.rental_contract_commercial',
  },
  {
    key: 'ticket.meeting.preference',
    value: 'resident_shared.ticket.meeting.preference',
  },
  {
    key: 'ticket.meeting.morning',
    value: 'resident_shared.ticket.meeting.morning',
  },
  {
    key: 'ticket.meeting.afternoon',
    value: 'resident_shared.ticket.meeting.afternoon',
  },
  {
    key: 'ticket.meeting.evening',
    value: 'resident_shared.ticket.meeting.evening',
  },
  {
    key: 'ticket.meeting.full_time',
    value: 'resident_shared.ticket.meeting.full_time',
  },
  {
    key: 'ticket.damage.images',
    value: 'resident_shared.ticket.damage.images',
  },
  {
    key: 'ticket.damage.review.question_completed',
    value: 'resident_shared.ticket.damage.review.question_completed',
  },
  {
    key: 'ticket.state.open',
    value: 'resident_shared.ticket.state.open',
  },
  {
    key: 'ticket.state.closed',
    value: 'resident_shared.ticket.state.closed',
  },
  {
    key: 'ticket.state.in_progress',
    value: 'resident_shared.ticket.state.in_progress',
  },
  {
    key: 'ticket.state.cancelled',
    value: 'resident_shared.ticket.state.cancelled',
  },
  {
    key: 'ticket.state.waiting_for_others',
    value: 'resident_shared.ticket.state.waiting_for_others',
  },
  {
    key: 'ticket.state.unexpected',
    value: 'resident_shared.ticket.state.unexpected',
  },
  {
    key: 'ticket.widget.title',
    value: 'resident_shared.ticket.widget.title',
  },
  {
    key: 'ticket.widget.menu.damage',
    value: 'resident_shared.ticket.widget.menu.damage',
  },
  {
    key: 'ticket.widget.menu.concern',
    value: 'resident_shared.ticket.widget.menu.concern',
  },
  {
    key: 'ticket.widget.menu.question',
    value: 'resident_shared.ticket.widget.menu.question',
  },
  {
    key: 'yes',
    value: 'resident_shared.yes',
  },
  {
    key: 'no',
    value: 'resident_shared.no',
  },
  {
    key: 'next',
    value: 'resident_shared.general.continue_a',
  },
  {
    key: 'utilities.tv',
    value: 'resident_shared.utilities.tv',
  },
  {
    key: 'utilities.electricity',
    value: 'resident_shared.utilities.electricity',
  },
  {
    key: 'utilities.cold_water',
    value: 'resident_shared.utilities.cold_water',
  },
  {
    key: 'utilities.hot_water',
    value: 'resident_shared.utilities.hot_water',
  },
  {
    key: 'utilities.heating',
    value: 'resident_shared.utilities.heating',
  },
  {
    key: 'utilities.gas',
    value: 'resident_shared.utilities.gas',
  },
  {
    key: 'utilities.phone',
    value: 'resident_shared.utilities.phone',
  },
  {
    key: 'miscellaneous',
    value: 'resident_shared.miscellaneous',
  },
  {
    key: 'building',
    value: 'resident_shared.building',
  },
  {
    key: 'outdoor_facility',
    value: 'resident_shared.outdoor_facility',
  },
  {
    key: 'garage_parking_space',
    value: 'resident_shared.garage_parking_space',
  },
  {
    key: 'step',
    value: 'resident_shared.step',
  },
  {
    key: 'street',
    value: 'resident_shared.street',
  },
  {
    key: 'number_short',
    value: 'resident_shared.number_short',
  },
  {
    key: 'apartment_number',
    value: 'resident_shared.apartment_number',
  },
  {
    key: 'floor',
    value: 'resident_shared.floor',
  },
  {
    key: 'outdoor_facilities.street_side',
    value: 'resident_shared.outdoor_facilities.street_side',
  },
  {
    key: 'outdoor_facilities.back',
    value: 'resident_shared.outdoor_facilities.back',
  },
  {
    key: 'outdoor_facilities.gable_end',
    value: 'resident_shared.outdoor_facilities.gable_end',
  },
  {
    key: 'outdoor_facilities.patio',
    value: 'resident_shared.outdoor_facilities.patio',
  },
  {
    key: 'outdoor_facilities_detailed.playground',
    value: 'resident_shared.outdoor_facilities_detailed.playground',
  },
  {
    key: 'outdoor_facilities_detailed.bicycle_parking_space',
    value: 'resident_shared.outdoor_facilities_detailed.bicycle_parking_space',
  },
  {
    key: 'outdoor_facilities_detailed.garbage_stand',
    value: 'resident_shared.outdoor_facilities_detailed.garbage_stand',
  },
  {
    key: 'outdoor_facilities_detailed.laundry_place',
    value: 'resident_shared.outdoor_facilities_detailed.laundry_place',
  },
  {
    key: 'outdoor_facilities_detailed.entrance_area',
    value: 'resident_shared.outdoor_facilities_detailed.entrance_area',
  },
  {
    key: 'outdoor_facilities_detailed.green_space',
    value: 'resident_shared.outdoor_facilities_detailed.green_space',
  },
  {
    key: 'outdoor_facilities_detailed.traffic_area',
    value: 'resident_shared.outdoor_facilities_detailed.traffic_area',
  },
  {
    key: 'outdoor_facilities_detailed.property_boundary',
    value: 'resident_shared.outdoor_facilities_detailed.property_boundary',
  },
  {
    key: 'describe_damage_title',
    value: 'resident_shared.describe_damage_title',
  },
  {
    key: 'parking_space_type.above_ground',
    value: 'resident_shared.parking_space_type.above_ground',
  },
  {
    key: 'parking_space_type.underground',
    value: 'resident_shared.parking_space_type.underground',
  },
  {
    key: 'parking_space_type.garage',
    value: 'resident_shared.parking_space_type.garage',
  },
  {
    key: 'parking_space_type.roadway',
    value: 'resident_shared.parking_space_type.roadway',
  },
  {
    key: 'parking_space_type.driveway',
    value: 'resident_shared.parking_space_type.driveway',
  },
  {
    key: 'pitch_number',
    value: 'resident_shared.pitch_number',
  },
  {
    key: 'garage_number',
    value: 'resident_shared.garage_number',
  },
  {
    key: 'apartament_place.bathroom',
    value: 'resident_shared.apartament_place.bathroom',
  },
  {
    key: 'apartament_place.living_room',
    value: 'resident_shared.apartament_place.living_room',
  },
  {
    key: 'apartament_place.bedroom',
    value: 'resident_shared.apartament_place.bedroom',
  },
  {
    key: 'apartament_place.childrens_study_room',
    value: 'resident_shared.apartament_place.childrens_study_room',
  },
  {
    key: 'apartament_place.corridor',
    value: 'resident_shared.apartament_place.corridor',
  },
  {
    key: 'apartament_place.storage_room_2',
    value: 'resident_shared.apartament_place.storage_room_2',
  },
  {
    key: 'apartament_place.kitchen',
    value: 'resident_shared.apartament_place.kitchen',
  },
  {
    key: 'apartament_place.balcony_terrace_loggia',
    value: 'resident_shared.apartament_place.balcony_terrace_loggia',
  },
  {
    key: 'damaged_text',
    value: 'resident_shared.damaged_text',
  },
  {
    key: 'appointment_preferences',
    value: 'resident_shared.appointment_preferences',
  },
  {
    key: 'personal_information_text',
    value: 'resident_shared.personal_information_text',
  },
  {
    key: 'general.done',
    value: 'resident_shared.general.done',
  },
  {
    key: 'general.open',
    value: 'resident_shared.general.open',
  },
  {
    key: 'general.close',
    value: 'resident_shared.general.close',
  },
  {
    key: 'archive.damage_header_text',
    value: 'resident_shared.archive.damage_header_text',
  },
  {
    key: 'archive.concern_header_text',
    value: 'resident_shared.archive.concern_header_text',
  },
  {
    key: 'general.archive',
    value: 'resident_shared.general.archive',
  },
  {
    key: 'general.back_a',
    value: 'resident_shared.general.back_a',
  },
  {
    key: 'archive_damage.no_data',
    value: 'resident_shared.archive_damage.no_data',
  },
  {
    key: 'active_damage.no_data',
    value: 'resident_shared.active_damage.no_data',
  },
  {
    key: 'archive_request.no_data',
    value: 'resident_shared.archive_request.no_data',
  },
  {
    key: 'active_request.no_data',
    value: 'resident_shared.active_request.no_data',
  },
  {
    key: 'search.category.news',
    value: 'resident_shared.search.category.news',
  },
  {
    key: 'search.category.offer',
    value: 'resident_shared.search.category.offer',
  },
  {
    key: 'search.category.announcement',
    value: 'resident_shared.search.category.announcement',
  },
  {
    key: 'search.category.damage_ticket',
    value: 'resident_shared.search.category.damage_ticket',
  },
  {
    key: 'search.category.request_ticket',
    value: 'resident_shared.search.category.request_ticket',
  },
  {
    key: 'search.category.contract',
    value: 'resident_shared.search.category.contract',
  },
  {
    key: 'search.category.function',
    value: 'resident_shared.search.category.function',
  },
  {
    key: 'consent.start',
    value: 'resident_shared.consent.start',
  },
  {
    key: 'consent.privacy-policy',
    value: 'resident_shared.consent.privacy-policy',
  },
  {
    key: 'consent.combining-filler',
    value: 'resident_shared.consent.combining-filler',
  },
  {
    key: 'consent.start_with_contact_name',
    value: 'resident_shared.consent.start_with_contact_name',
  },
  {
    key: 'consent.conditions',
    value: 'resident_shared.consent.conditions',
  },
  {
    key: 'consent.end',
    value: 'resident_shared.consent.end',
  },
  {
    key: 'user_profile.delete_user_success_m',
    value: 'resident_shared.user_profile.delete_user_success_m',
  },
  {
    key: 'user_profile.load_legal_texts_error_m',
    value: 'resident_shared.user_profile.load_legal_texts_error_m',
  },
  {
    key: 'user_profile.change_email_error_m',
    value: 'resident_shared.user_profile.change_email_error_m',
  },
  {
    key: 'user_profile.delete_user_error_m',
    value: 'resident_shared.user_profile.delete_user_error_m',
  },
  {
    key: 'general.error_undefined',
    value: 'resident_shared.general.error_undefined',
  },
  {
    key: 'general.error_undefined_title',
    value: 'resident_shared.general.error_undefined_title',
  },
  {
    key: 'auth.error_wrong_credentials',
    value: 'resident_shared.auth.error_wrong_credentials',
  },
  {
    key: 'unexpected_error_m',
    value: 'resident_shared.unexpected_error_m',
  },
  {
    key: 'ticket_active_concerns_l',
    value: 'resident_shared.ticket_active_concerns_l',
  },
  {
    key: 'ticket_active_damages_l',
    value: 'resident_shared.ticket_active_damages_l',
  },
  {
    key: 'ticket_concerns_l',
    value: 'resident_shared.ticket_concerns_l',
  },
  {
    key: 'ticket_damages_l',
    value: 'resident_shared.ticket_damages_l',
  },
  {
    key: 'user_profile.date_of_birth_l',
    value: 'resident_shared.user_profile.date_of_birth_l',
  },
  {
    key: 'user_profile.contact_details_l',
    value: 'resident_shared.user_profile.contact_details_l',
  },
  {
    key: 'user_profile.escrowed_account_l',
    value: 'resident_shared.user_profile.escrowed_account_l',
  },
  {
    key: 'user_profile.payment_information_l',
    value: 'resident_shared.user_profile.payment_information_l',
  },
  {
    key: 'user_profile.payment_informations_l',
    value: 'resident_shared.user_profile.payment_informations_l',
  },
  {
    key: 'user_profile.address_l',
    value: 'resident_shared.user_profile.address_l',
  },
  {
    key: 'user_profile.sepa_direct_debit_mandate_l',
    value: 'resident_shared.user_profile.sepa_direct_debit_mandate_l',
  },
  {
    key: 'user_profile.indefinitely_since_l',
    value: 'resident_shared.user_profile.indefinitely_since_l',
  },
  {
    key: 'user_profile.lastname',
    value: 'resident_shared.user_profile.lastname',
  },
  {
    key: 'user_profile.request_change_a',
    value: 'resident_shared.user_profile.request_change_a',
  },
  {
    key: 'user_profile.load_personal_data_error_m',
    value: 'resident_shared.user_profile.load_personal_data_error_m',
  },
  {
    key: 'general.in_l',
    value: 'resident_shared.general.in_l',
  },
  {
    key: 'register.request_invitation_invalid_input',
    value: 'resident_shared.register.request_invitation_invalid_input',
  },
  {
    key: 'general.reset_password',
    value: 'resident_shared.general.reset_password',
  },
  {
    key: 'general.reset_password_a',
    value: 'resident_shared.general.reset_password_a',
  },
  {
    key: 'guest_mode.no_access_a',
    value: 'resident_shared.guest_mode.no_access_a',
  },
  {
    key: 'settings.logout',
    value: 'resident_shared.settings.logout',
  },
  {
    key: 'auth.forgot_password',
    value: 'resident_shared.auth.forgot_password',
  },
  {
    key: 'service.send_reset_pw_link',
    value: 'resident_shared.service.send_reset_pw_link',
  },
  {
    key: 'tickets.report_damage',
    value: 'resident_shared.tickets.report_damage',
  },
  {
    key: 'tickets.report_concern',
    value: 'resident_shared.tickets.report_concern',
  },
  {
    key: 'select_hint_l',
    value: 'resident_shared.select_hint_l',
  },
  {
    key: 'no_access_please_login',
    value: 'resident_shared.no_access_please_login',
  },
  {
    key: 'to_login_a',
    value: 'resident_shared.to_login_a',
  },
  {
    key: 'ticket.b_and_o_title_l',
    value: 'resident_shared.ticket.b_and_o_title_l',
  },
  {
    key: 'ticket.b_and_o_short_description_l',
    value: 'resident_shared.ticket.b_and_o_short_description_l',
  },
  {
    key: 'ticket.b_and_o_button',
    value: 'resident_shared.ticket.b_and_o_button',
  },
  {
    key: 'ticket.b_and_o_header_l',
    value: 'resident_shared.ticket.b_and_o_header_l',
  },
  {
    key: 'apartments',
    value: 'resident_shared.apartments',
  },
  {
    key: 'to_apartments',
    value: 'resident_shared.to_apartments',
  },
  {
    key: 'location',
    value: 'resident_shared.location',
  },
  {
    key: 'zip',
    value: 'resident_shared.zip',
  },
  {
    key: 'user.profile_details_l',
    value: 'resident_shared.user.profile_details_l',
  },
  {
    key: 'account.edit_data_a',
    value: 'resident_shared.account.edit_data_a',
  },
  {
    key: 'tab.contracts_l',
    value: 'resident_shared.tab.contracts_l',
  },
  {
    key: 'tab.documents_l',
    value: 'resident_shared.tab.documents_l',
  },
  {
    key: 'payment_request.for_l',
    value: 'resident_shared.payment_request.for_l',
  },
  {
    key: 'payment_request.due_l',
    value: 'resident_shared.payment_request.due_l',
  },
  {
    key: 'payment_request.overdue_l',
    value: 'resident_shared.payment_request.overdue_l',
  },
  {
    key: 'payment_request.status_error_l',
    value: 'resident_shared.payment_request.status_error_l',
  },
  {
    key: 'payment_request.open_request_l',
    value: 'resident_shared.payment_request.open_request_l',
  },
  {
    key: 'navigation.collapse_sidebar_a',
    value: 'resident_shared.navigation.collapse_sidebar_a',
  },
  {
    key: 'navigation.expand_sidebar_a',
    value: 'resident_shared.navigation.expand_sidebar_a',
  },
  {
    key: 'payment_request.paid_l',
    value: 'resident_shared.payment_request.paid_l',
  },
  {
    key: 'consumption_detail.month_january_l',
    value: 'resident_shared.consumption_detail.month_january_l',
  },
  {
    key: 'consumption_detail.month_february_l',
    value: 'resident_shared.consumption_detail.month_february_l',
  },
  {
    key: 'consumption_detail.month_march_l',
    value: 'resident_shared.consumption_detail.month_march_l',
  },
  {
    key: 'consumption_detail.month_april_l',
    value: 'resident_shared.consumption_detail.month_april_l',
  },
  {
    key: 'consumption_detail.month_may_l',
    value: 'resident_shared.consumption_detail.month_may_l',
  },
  {
    key: 'consumption_detail.month_june_l',
    value: 'resident_shared.consumption_detail.month_june_l',
  },
  {
    key: 'consumption_detail.month_july_l',
    value: 'resident_shared.consumption_detail.month_july_l',
  },
  {
    key: 'consumption_detail.month_august_l',
    value: 'resident_shared.consumption_detail.month_august_l',
  },
  {
    key: 'consumption_detail.month_september_l',
    value: 'resident_shared.consumption_detail.month_september_l',
  },
  {
    key: 'consumption_detail.month_october_l',
    value: 'resident_shared.consumption_detail.month_october_l',
  },
  {
    key: 'consumption_detail.month_november_l',
    value: 'resident_shared.consumption_detail.month_november_l',
  },
  {
    key: 'consumption_detail.month_december_l',
    value: 'resident_shared.consumption_detail.month_december_l',
  },
  {
    key: 'unauthorized_user.header_l',
    value: 'resident_shared.unauthorized_user.header_l',
  },
  {
    key: 'unauthorized_user.title_l',
    value: 'resident_shared.unauthorized_user.title_l',
  },
  {
    key: 'unauthorized_user.description_l',
    value: 'resident_shared.unauthorized_user.description_l',
  },
  {
    key: 'unauthorized_user.button_a',
    value: 'resident_shared.unauthorized_user.button_a',
  },
  {
    key: 'contracts.choose_contract_l',
    value: 'resident_shared.contracts.choose_contract_l',
  },
  {
    key: 'payment_requests.archive_requests_l',
    value: 'resident_shared.payment_requests.archive_requests_l',
  },
  {
    key: 'payment_requests.archive_no_requests_l',
    value: 'resident_shared.payment_requests.archive_no_requests_l',
  },
  {
    key: 'contracts.account_balance_title',
    value: 'resident_shared.contracts.account_balance_title',
  },
  {
    key: 'contracts.account_balance_negative_l',
    value: 'resident_shared.contracts.account_balance_negative_l',
  },
  {
    key: 'contracts.account_balance_info_title',
    value: 'resident_shared.contracts.account_balance_info_title',
  },
  {
    key: 'contracts.landlord_bank_account.title',
    value: 'resident_shared.contracts.landlord_bank_account.title',
  },
  {
    key: 'bank_account.bank',
    value: 'resident_shared.bank_account.bank',
  },
  {
    key: 'bank_account.owner',
    value: 'resident_shared.bank_account.owner',
  },
  {
    key: 'bank_account.iban',
    value: 'resident_shared.bank_account.iban',
  },
  {
    key: 'bank_account.bic',
    value: 'resident_shared.bank_account.bic',
  },
  {
    key: 'contract_id_l',
    value: 'resident_shared.contract_id_l',
  },
  {
    key: 'contract_start_l',
    value: 'resident_shared.contract_start_l',
  },
  {
    key: 'contract_period_l',
    value: 'resident_shared.contract_period_l',
  },
  {
    key: 'valid_from_l',
    value: 'resident_shared.valid_from_l',
  },
  {
    key: 'dialog_alert_title_l',
    value: 'resident_shared.dialog_alert_title_l',
  },
  {
    key: 'dialog_info_title_l',
    value: 'resident_shared.dialog_info_title_l',
  },
  {
    key: 'dialog_warning_title_l',
    value: 'resident_shared.dialog_warning_title_l',
  },
  {
    key: 'token-expired-info',
    value: 'resident_shared.token-expired-info',
  },
  {
    key: 'dashboard.more_announcements_l',
    value: 'resident_shared.dashboard.more_announcements_l',
  },
  {
    key: 'dashboard.more_tickets_l',
    value: 'resident_shared.dashboard.more_tickets_l',
  },
  {
    key: 'permissions.call',
    value: 'permissions.call',
  },
  {
    key: 'year',
    value: 'resident_shared.year',
  },
  {
    key: 'month',
    value: 'resident_shared.month',
  },
  {
    key: 'ticket_creation.create_ticket_a',
    value: 'resident_shared.ticket_creation.create_ticket_a',
  },
  {
    key: 'user.lastname',
    value: 'resident_shared.user.lastname',
  },
  {
    key: 'logo_fallback',
    value: 'resident_shared.logo_fallback',
  },
  {
    key: 'update_available',
    value: 'resident_shared.update_available',
  },
  {
    key: 'general.cancel',
    value: 'resident_shared.general.cancel',
  },
  {
    key: 'general.accept',
    value: 'resident_shared.general.accept',
  },
  {
    key: 'general.decline',
    value: 'resident_shared.general.decline',
  },
  {
    key: 'general.change_password',
    value: 'resident_shared.general.change_password',
  },
  {
    key: 'user.change_password_desc',
    value: 'resident_shared.user.change_password_desc',
  },
  {
    key: 'user.change_password_description',
    value: 'resident_shared.user.change_password_description',
  },
  {
    key: 'user.change_password.confirm',
    value: 'resident_shared.user.change_password.confirm',
  },
  {
    key: 'user.change_password_shared_credentials_m',
    value: 'resident_shared.user.change_password_shared_credentials_m',
  },
  {
    key: 'legal.document_receival',
    value: 'resident_shared.legal.document_receival',
  },
  {
    key: 'legal.document_receival_start',
    value: 'resident_shared.legal.document_receival_start',
  },
  {
    key: 'legal.document_receival_link',
    value: 'resident_shared.legal.document_receival_link',
  },
  {
    key: 'legal.document_receival_end',
    value: 'resident_shared.legal.document_receival_end',
  },
  {
    key: 'legal.document_receival_l',
    value: 'resident_shared.legal.document_receival_l',
  },
  {
    key: 'general.offline_header',
    value: 'resident_shared.general.offline_header',
  },
  {
    key: 'general.offline_body',
    value: 'resident_shared.general.offline_body',
  },
  {
    key: 'general.email_address',
    value: 'resident_shared.general.email_address',
  },
  {
    key: 'general.login_email',
    value: 'resident_shared.general.login_email',
  },
  {
    key: 'general.ios_update_banner_title',
    value: 'resident_shared.general.ios_update_banner_title',
  },
  {
    key: 'general.ios_update_banner_body',
    value: 'resident_shared.general.ios_update_banner_body',
  },
  {
    key: 'general.ios_update_banner_update_button',
    value: 'resident_shared.general.ios_update_banner_update_button',
  },
  {
    key: 'general.ios_update_banner_skip_button',
    value: 'resident_shared.general.ios_update_banner_skip_button',
  },
  {
    key: 'contracts.unknown_cost',
    value: 'resident_shared.contracts.unknown_cost',
  },
  {
    key: 'information_notice_description',
    value: 'resident_shared.information_notice_description',
  },
  {
    key: 'information_notice_title_l',
    value: 'resident_shared.information_notice_title_l',
  },
  {
    key: 'ticket_chat_message_status_failed_l',
    value: 'resident_shared.ticket_chat.message_status_failed_l',
  },
  {
    key: 'ticket_chat_message_status_retried_l',
    value: 'resident_shared.ticket_chat.message_status_retried_l',
  },
  {
    key: 'ticket_chat_message_status_pending_l',
    value: 'resident_shared.ticket_chat.message_status_pending_l',
  },
  {
    key: 'consumption.estimated_value',
    value: 'resident_shared.consumption.estimated_value',
  },
  {
    key: 'consumption.real_value',
    value: 'resident_shared.consumption.real_value',
  },
  {
    key: 'faq_widget_l',
    value: 'resident_shared.faq_widget.faqs_l',
  },
  {
    key: 'faq_widget_description',
    value: 'resident_shared.faq_widget.faqs_description',
  },
  {
    key: 'upload_file_l',
    value: 'resident_shared.upload_file_l',
  },
  {
    key: 'upload_total_file_size_l',
    value: 'resident_shared.upload_total_file_size_l',
  },
  {
    key: 'upload_max_file_size_l',
    value: 'resident_shared.upload_max_file_size_l',
  },
  {
    key: 'upload_invalid_file_type_l',
    value: 'resident_shared.upload_invalid_file_type_l',
  },
  {
    key: 'user_edit_heading',
    value: 'resident_shared.user_edit_page.heading',
  },
  {
    key: 'user_edit_l',
    value: 'resident_shared.user_edit_page.user_edit_l',
  },
  {
    key: 'user_edit_ticket_l',
    value: 'resident_shared.user_edit_page.user_edit_ticket_l',
  },
  {
    key: 'user_edit_desc',
    value: 'resident_shared.user_edit_page.user_edit_desc',
  },
  {
    key: 'user_name_edit.form_l',
    value: 'resident_shared.user_name_edit.form_l',
  },
  {
    key: 'user_name_edit_firstname_l',
    value: 'resident_shared.user_name_edit.form_firstname_l',
  },
  {
    key: 'user_name_edit_lastname_l',
    value: 'resident_shared.user_name_edit.form_lastname_l',
  },
  {
    key: 'user_name_edit_attactment_l',
    value: 'resident_shared.user_name_edit.form_attactment_l',
  },
  {
    key: 'user_edit.button_l',
    value: 'resident_shared.user_edit.button_l',
  },
  {
    key: 'user_birth_date_edit.form_l',
    value: 'resident_shared.user_birth_date_edit.form_l',
  },
  {
    key: 'user_address_edit.form_l',
    value: 'resident_shared.user_address_edit.form_l',
  },
  {
    key: 'user_address_edit_street_l',
    value: 'resident_shared.user_address_edit.form_street_l',
  },
  {
    key: 'user_address_edit_house_number_l',
    value: 'resident_shared.user_address_edit.form_house_number_l',
  },
  {
    key: 'user_address_edit_postcode_l',
    value: 'resident_shared.user_address_edit.form_postcode_l',
  },
  {
    key: 'user_address_edit_city_l',
    value: 'resident_shared.user_address_edit.form_city_l',
  },
  {
    key: 'user_phone_edit.form_l',
    value: 'resident_shared.user_phone_edit.form_l',
  },
  {
    key: 'user_payment_edit.form_l',
    value: 'resident_shared.user_payment_edit.form_l',
  },
  {
    key: 'user_phone_edit_country_code_l',
    value: 'resident_shared.user_phone_edit.form_country_code_l',
  },
  {
    key: 'user_phone_edit_country_code_label_l',
    value: 'resident_shared.user_phone_edit.form_country_code_label_l',
  },
  {
    key: 'user_phone_edit_country_code_placeholder_l',
    value: 'resident_shared.user_phone_edit.form_country_code_placeholder_l',
  },
  {
    key: 'user_phone_edit_prefix_l',
    value: 'resident_shared.user_phone_edit.form_prefix_l',
  },
  {
    key: 'user_phone_edit_number_l',
    value: 'resident_shared.user_phone_edit.form_number_l',
  },
  {
    key: 'user_mobile_phone_edit.form_l',
    value: 'resident_shared.user_mobile_phone_edit.form_l',
  },
  {
    key: 'user_email_edit.form_l',
    value: 'resident_shared.user_email_edit.form_l',
  },
  {
    key: 'user_email_edit.form_desc',
    value: 'resident_shared.user_email_edit.form_desc',
  },
  {
    key: 'user_payment_edit.form_h',
    value: 'resident_shared.user_payment_edit.form_h',
  },
  {
    key: 'user_payment_edit.form_iban_l',
    value: 'resident_shared.payment_edit.form_iban_l',
  },
  {
    key: 'user_payment_edit.form_account_holder_l',
    value: 'resident_shared.payment_edit.form_account_holder_l',
  },
  {
    key: 'user_payment_edit.form_issued_at_l',
    value: 'resident_shared.payment_edit.form_issued_at_l',
  },
  {
    key: 'user_payment_edit.form_valid_contract_selection_l',
    value: 'resident_shared.payment_edit.form_valid_contract_selection_l',
  },
  {
    key: 'user_payment_edit.form_contracts_l',
    value: 'resident_shared.payment_edit.form_contracts_l',
  },
  {
    key: 'user_payment_edit.form_valid_contract_selection_chip_l',
    value: 'resident_shared.payment_edit.form_valid_contract_selection_chip_l',
  },
  {
    key: 'user_payment_edit.form_save_new_payment_toggle_l',
    value: 'resident_shared.payment_edit.form_save_new_payment_toggle_l',
  },
  {
    key: 'user_payment_edit.form_direct_debit_concent_toggle_start',
    value: 'resident_shared.payment_edit.form_direct_debit_concent_toggle_start',
  },
  {
    key: 'user_payment_edit.form_direct_debit_concent_toggle_link',
    value: 'resident_shared.payment_edit.form_direct_debit_concent_toggle_link',
  },
  {
    key: 'user_payment_edit.form_direct_debit_concent_toggle_end',
    value: 'resident_shared.payment_edit.form_direct_debit_concent_toggle_end',
  },
  {
    key: 'user_payment_edit.form_sepa_text_l',
    value: 'resident_shared.payment_edit.form_sepa_text_l',
  },
  {
    key: 'user_payment_edit.form_note_h',
    value: 'resident_shared.payment_edit.form_note_h',
  },
  {
    key: 'user_payment_edit.error_desc_1',
    value: 'resident_shared.payment_edit.error_desc_1',
  },
  {
    key: 'user_payment_edit.error_desc_2',
    value: 'resident_shared.payment_edit.error_desc_2',
  },
  {
    key: 'user_edit_error.request_exists',
    value: 'resident_shared.user_edit_error.request_exists',
  },
  {
    key: 'user_payment_edit.half_error_desc_1',
    value: 'resident_shared.payment_edit.half_error_desc_1',
  },
  {
    key: 'user_payment_edit.half_error_desc_2',
    value: 'resident_shared.payment_edit.half_error_desc_2',
  },
  {
    key: 'user_payment_edit.half_error_desc_3',
    value: 'resident_shared.payment_edit.half_error_desc_3',
  },
  {
    key: 'user_edit_overview_l',
    value: 'resident_shared.user_edit_overview_l',
  },
  {
    key: 'user_edit_overview_title_l',
    value: 'resident_shared.user_edit_overview_title_l',
  },
  {
    key: 'user_edit_success_desc_1',
    value: 'resident_shared.user_edit_success_desc_1',
  },
  {
    key: 'user_edit_success_desc_2',
    value: 'resident_shared.user_edit_success_desc_2',
  },
  {
    key: 'user_edit_error_heading',
    value: 'resident_shared.user_edit_error_page.heading',
  },
  {
    key: 'user_edit_half_error_heading',
    value: 'resident_shared.user_edit_half_error_page.heading',
  },
  {
    key: 'user_edit_payment_not_allowed_restriction_period_h',
    value: 'resident_shared.user_edit_payment_not_allowed_restriction_period_h',
  },
  {
    key: 'user_edit_error_title',
    value: 'resident_shared.user_edit_error_page.title',
  },
  {
    key: 'open_request_desc_1',
    value: 'resident_shared.user_edit_error_page.open_request_desc_1',
  },
  {
    key: 'open_request_desc_2',
    value: 'resident_shared.user_edit_error_page.open_request_desc_2',
  },
  {
    key: 'open_request_desc_3',
    value: 'resident_shared.user_edit_error_page.open_request_desc_3',
  },
  {
    key: 'erp_desc_1',
    value: 'resident_shared.user_edit_error_page.erp_desc_1',
  },
  {
    key: 'erp_desc_2',
    value: 'resident_shared.user_edit_error_page.erp_desc_2',
  },
  {
    key: 'hint_l',
    value: 'resident_shared.hint_l',
  },
  {
    key: 'user_edit_desc_no_hint',
    value: 'resident_shared.user_edit_page.user_edit_desc_no_hint',
  },
  {
    key: 'concern_l',
    value: 'resident_shared.concern_l',
  },
  {
    key: 'verification_l',
    value: 'resident_shared.verification_l',
  },
  {
    key: 'submit_l',
    value: 'resident_shared.submit_l',
  },
  {
    key: 'edit_profile_ticket_hint_l',
    value: 'resident_shared.edit_profile_ticket_hint_l',
  },
  {
    key: 'back_to_overview_l',
    value: 'resident_shared.back_to_overview_l',
  },
  {
    key: 'service.total_rent_l',
    value: 'resident_shared.service.total_rent_l',
  },
  {
    key: 'upload_file_l',
    value: 'resident_shared.upload_file_l',
  },
  {
    key: 'tickets.damages_attachment_error_l',
    value: 'resident_saas.tickets.damages_attachment_error_l',
  },
  {
    key: 'forms.invalid_name_l',
    value: 'resident_shared.account.name_input_incorrect',
  },
  {
    key: 'forms.invalid_phone_prefix_l',
    value: 'resident_shared.validation_error.phone_prefix_invalid_l',
  },
  {
    key: 'forms.invalid_phone_number_l',
    value: 'resident_shared.validation_error.phone_invalid_l',
  },
  {
    key: 'forms.minlength_l',
    value: 'resident_saas.forms.minlength_l',
  },
  {
    key: 'forms.maxlength_l',
    value: 'resident_saas.forms.maxlength_l',
  },
  {
    key: 'forms.invalid_zipcode_l',
    value: 'resident_shared.forms.invalid_zipcode_l',
  },
  {
    key: 'forms.invalid_iban_l',
    value: 'resident_shared.forms.invalid_iban_l',
  },
  {
    key: 'user_profile.name',
    value: 'resident_shared.user_profile.name',
  },
  {
    key: 'user_profile.only_name',
    value: 'resident_shared.user_profile.only_name',
  },
  {
    key: 'general.expand_all_l',
    value: 'resident_shared.general.expand_all_l',
  },
  {
    key: 'general.collapse_all_l',
    value: 'resident_shared.general.collapse_all_l',
  },
  {
    key: 'unverified_user.title_l',
    value: 'resident_shared.unverified_user.title_l',
  },
  {
    key: 'unverified_user.header_l',
    value: 'resident_shared.unverified_user.header_l',
  },
  {
    key: 'unverified_user.description_l',
    value: 'resident_shared.unverified_user.description_l',
  },
  {
    key: 'unverified_user.no_verification_message_l',
    value: 'resident_shared.unverified_user.no_verification_message_l',
  },
  {
    key: 'unverified_user.resend_link_l',
    value: 'resident_shared.unverified_user.resend_link_l',
  },
  {
    key: 'unverified_user.continue_to_login_a',
    value: 'resident_shared.unverified_user.continue_to_login_a',
  },
  {
    key: 'unverified_user.resend_link_info',
    value: 'resident_shared.unverified_user.resend_link_info',
  },
  {
    key: 'unverified_user.resend_link_error',
    value: 'resident_shared.unverified_user.resend_link_error',
  },
  {
    key: 'user_payment_edit_page_heading',
    value: 'resident_shared.user_payment_edit_page.heading',
  },
  {
    key: 'consumption.no_chart_data_l',
    value: 'resident_shared.consumption.no_chart_data_l',
  },
  {
    key: 'user_edit_success_desc_payment',
    value: 'resident_shared.user_edit_success_desc_payment',
  },
  {
    key: 'account.cooperative_data',
    value: 'resident_shared.account.cooperative_data',
  },
  {
    key: 'account.cooperative_data_membership_number',
    value: 'resident_shared.account.cooperative_data_membership_number',
  },
  {
    key: 'account.cooperative_data_entry_date',
    value: 'resident_shared.account.cooperative_data_entry_date',
  },
  {
    key: 'account.cooperative_data_leaving_date',
    value: 'resident_shared.account.cooperative_data_leaving_date',
  },
  {
    key: 'feedback.no_mail_app_description_l',
    value: 'resident_shared.feedback.no_mail_app_description_l',
  },
  {
    key: 'feedback.call_app_failure_description_l',
    value: 'resident_shared.feedback.call_app_failure_description_l',
  },
  {
    key: 'contracts.payment_interval_l',
    value: 'resident_shared.contracts.payment_interval_l',
  },
  {
    key: 'a11y_alt_tag.success_l',
    value: 'resident_shared.a11y_alt_tag.success_l',
  },
  {
    key: 'a11y_alt_tag.waiting_l',
    value: 'resident_shared.a11y_alt_tag.waiting_l',
  },
  {
    key: 'a11y_alt_tag.registration_success_l',
    value: 'resident_shared.a11y_alt_tag.registration_success_l',
  },
  {
    key: 'a11y_alt_tag.errors_l',
    value: 'resident_shared.a11y_alt_tag.errors_l',
  },
  {
    key: 'a11y_alt_tag.password_reset_l',
    value: 'resident_shared.a11y_alt_tag.password_reset_l',
  },
  {
    key: 'a11y_alt_tag.searching_l',
    value: 'resident_shared.a11y_alt_tag.searching_l',
  },
  {
    key: ' a11y_alt_tag.mail_l',
    value: 'resident_shared.a11y_alt_tag.mail_l',
  },
  {
    key: 'a11y_alt_tag.order_placed_l',
    value: 'resident_shared.a11y_alt_tag.order_placed_l',
  },
  {
    key: 'a11y_alt_tag.unauthorized_l',
    value: 'resident_shared.a11y_alt_tag.unauthorized_l',
  },
  {
    key: 'a11y_alt_tag.address_change_l',
    value: 'resident_shared.a11y_alt_tag.address_change_l',
  },
  {
    key: 'a11y_alt_tag.email_send_l',
    value: 'resident_shared.a11y_alt_tag.email_send_l',
  },
  {
    key: 'a11y_alt_tag.documents_l',
    value: 'resident_shared.a11y_alt_tag.documents_l',
  },
  {
    key: 'ticket_creation.success.text_1_l',
    value: 'resident_saas.ticket_creation.success.text_1_l',
  },
  {
    key: 'ticket_creation.success.text_2_l',
    value: 'resident_saas.ticket_creation.success.text_2_l',
  },
  {
    key: 'ticket_creation.success.text_3_l',
    value: 'resident_saas.ticket_creation.success.text_3_l',
  },
  {
    key: 'ticket_creation.success.text_metadata_l',
    value: 'resident_saas.ticket_creation.success.text_metadata_l',
  },
  {
    key: 'documents.requested_title_l',
    value: 'resident_shared.documents.requested_title_l',
  },
  {
    key: 'documents.unavailable_title_l',
    value: 'resident_shared.documents.unavailable_title_l',
  },
  {
    key: 'documents.unavailable_desc_l',
    value: 'resident_shared.documents.unavailable_desc_l',
  },
  {
    key: 'documents.requested_desc_1_l',
    value: 'resident_shared.documents.requested_desc_1_l',
  },
  {
    key: 'documents.requested_desc_2_l',
    value: 'resident_shared.documents.requested_desc_2_l',
  },
  {
    key: 'documents.requested_end_l',
    value: 'resident_shared.documents.requested_end_l',
  },
  {
    key: 'documents.requested_back_btn_l',
    value: 'resident_shared.documents.requested_back_btn_l',
  },
  {
    key: 'consumption_comparison.info_desc_l',
    value: 'resident_saas.consumption_comparison.info_desc_l',
  },
  {
    key: 'consumption_comparison.info_title_l',
    value: 'resident_saas.consumption_comparison.info_title_l',
  },
  {
    key: 'user_profile.title_l',
    value: 'resident_shared.user_profile.title',
  },
  {
    key: 'ticket.ticket_id',
    value: 'resident_shared.ticket.ticket_id',
  },
  {
    key: 'general.copied',
    value: 'resident_shared.general.copied',
  },
  {
    key: 'sepa_indefinitely_since_l',
    value: 'resident_shared.user_profile.sepa_indefinitely_since_l',
  },
  {
    key: 'ticket_creation.error_screen_message_l',
    value: 'resident_saas.ticket_creation.error_screen_message_l',
  },
  {
    key: 'ticket_creation.try_again_a',
    value: 'resident_saas.ticket_creation.try_again_a',
  },
  {
    key: 'multiselect.items_selected_l',
    value: 'resident_shared.multiselect.items_selected_l',
  },
  {
    key: 'multiselect.choose_item_l',
    value: 'resident_shared.multiselect.choose_item_l',
  },
  {
    key: 'multiselect.reset_l',
    value: 'resident_shared.multiselect.reset_l',
  },
  {
    key: 'multiselect.accept_l',
    value: 'resident_shared.multiselect.accept_l',
  },
  {
    key: 'immomio_dropdown.android_done_l',
    value: 'resident_shared.immomio_dropdown.android_done_l',
  },
  {
    key: 'downtime.header_l',
    value: 'resident_shared.downtime.header_l',
  },
  {
    key: 'downtime.title_l',
    value: 'resident_shared.downtime.title_l',
  },
  {
    key: 'edit_payment_not_allowed_restriction_period',
    value: 'resident_shared.edit_payment_not_allowed_restriction_period',
  },
  {
    key: 'general.privacy',
    value: 'resident_shared.general.privacy',
  },
  {
    key: 'chat_bot_consent.header_title_h',
    value: 'resident_shared.chat_bot_consent.header_title_h',
  },
  {
    key: 'chat_bot_consent.title_h',
    value: 'resident_shared.chat_bot_consent.title_h',
  },
  {
    key: 'chat_bot_consent.accept_btn_l',
    value: 'resident_shared.chat_bot_consent.accept_btn_l',
  },
  {
    key: 'chat_bot_consent.check_box_l',
    value: 'resident_shared.chat_bot_consent.check_box_l',
  },
  {
    key: 'chat_bot.button_l',
    value: 'resident_shared.chat_bot.button_l',
  },
  {
    key: 'chat_bot.welcome_l',
    value: 'resident_shared.chat_bot.welcome_l',
  },
  {
    key: 'chat_bot.title_l',
    value: 'resident_shared.chat_bot.title_l',
  },
  {
    key: 'chat_bot.welcome_mobile_l',
    value: 'resident_shared.chat_bot.welcome_mobile_l',
  },
  {
    key: 'register.password_repeat_invalid_l',
    value: 'resident_shared.register.password_repeat_invalid_l',
  },
  {
    key: 'pw_set_form.password_repeat_l',
    value: 'resident_shared.pw_set_form.password_repeat_l',
  },
  {
    key: 'consent.terms_and_conditions_start',
    value: 'resident_shared.consent.terms_and_conditions_start',
  },
  {
    key: 'consent.terms_and_conditions_link',
    value: 'resident_shared.consent.terms_and_conditions_link',
  },
  {
    key: 'consent.terms_and_conditions_end',
    value: 'resident_shared.consent.terms_and_conditions_end',
  },
  {
    key: 'consent.terms_and_conditions_l',
    value: 'resident_shared.consent.terms_and_conditions_l',
  },
  {
    key: 'consent.terms_and_conditions_title',
    value: 'resident_shared.consent.terms_and_conditions_title',
  },
  {
    key: 'consent.data_policy_l',
    value: 'resident_shared.consent.data_policy_l',
  },
  {
    key: 'consent.data_policy_title',
    value: 'resident_shared.consent.data_policy_title',
  },
  {
    key: 'consent.data_policy_start',
    value: 'resident_shared.consent.data_policy_start',
  },
  {
    key: 'consent.data_policy_link',
    value: 'resident_shared.consent.data_policy_link',
  },
  {
    key: 'consent.data_policy_end',
    value: 'resident_shared.consent.data_policy_end',
  },
  {
    key: 'consent.document_consent_l',
    value: 'resident_shared.consent.document_consent_l',
  },
  {
    key: 'consent.document_consent_title',
    value: 'resident_shared.consent.document_consent_title',
  },
  {
    key: 'consent.document_consent_start',
    value: 'resident_shared.consent.document_consent_start',
  },
  {
    key: 'consent.document_consent_link',
    value: 'resident_shared.consent.document_consent_link',
  },
  {
    key: 'consent.document_consent_checkbox_l',
    value: 'resident_shared.consent.document_consent_checkbox_l',
  },
  {
    key: 'save_consent_failed_l',
    value: 'resident_shared.consent.save_consent_failed_l',
  },
  {
    key: 'a11y.password_toggle_icon_deactivated',
    value: 'resident_shared.a11y.password_toggle_icon_deactivated',
  },
  {
    key: 'a11y.password_toggle_icon_activated',
    value: 'resident_shared.a11y.password_toggle_icon_activated',
  },
  {
    key: 'a11y.password_form_checkbox_terms_l',
    value: 'resident_shared.a11y.password_form_checkbox_terms_l',
  },
  {
    key: 'a11y.password_form_checkbox_documents_l',
    value: 'resident_shared.a11y.password_form_checkbox_documents_l',
  },
  {
    key: 'contract.object_info_h',
    value: 'resident_shared.contract.object_info_h',
  },
  {
    key: 'contract.object_info.deposit',
    value: 'resident_shared.contract.object_info.deposit',
  },
  {
    key: 'contract.object_info.floor',
    value: 'resident_shared.contract.object_info.floor',
  },
  {
    key: 'contract.object_info.rooms',
    value: 'resident_shared.contract.object_info.rooms',
  },
  {
    key: 'contract.object_info.half_rooms',
    value: 'resident_shared.contract.object_info.half_rooms',
  },
  {
    key: 'contract.object_info.living_space',
    value: 'resident_shared.contract.object_info.living_space',
  },
  {
    key: 'contract.object_info.deposit_awaiting',
    value: 'resident_shared.contract.object_info.deposit_awaiting',
  },
  {
    key: 'welcome.welcome_header_l',
    value: 'resident_shared.welcome.welcome_header_l',
  },
  {
    key: 'welcome.welcome_h',
    value: 'resident_shared.welcome.welcome_h',
  },
  {
    key: 'welcome.welcome_desc_l',
    value: 'resident_shared.welcome.welcome_desc_l',
  },
  {
    key: 'welcome.warning_h',
    value: 'resident_shared.welcome.warning_h',
  },
  {
    key: 'welcome.warning_desc_l',
    value: 'resident_shared.welcome.warning_desc_l',
  },
  {
    key: 'welcome.button_login_l',
    value: 'resident_shared.welcome.button_login_l',
  },
  {
    key: 'welcome.button_register_l',
    value: 'resident_shared.welcome.button_register_l',
  },
  {
    key: 'onboarding.header_h',
    value: 'resident_shared.onboarding.header_h',
  },
  {
    key: 'onboarding.button_skip_l',
    value: 'resident_shared.onboarding.button_skip_l',
  },
  {
    key: 'onboarding.button_next_l',
    value: 'resident_shared.onboarding.button_next_l',
  },
  {
    key: 'onboarding.button_back_l',
    value: 'resident_shared.onboarding.button_back_l',
  },
  {
    key: 'onboarding.button_get_started_l',
    value: 'resident_shared.onboarding.button_get_started_l',
  },
  {
    key: 'onboarding.1_title_h',
    value: 'resident_shared.onboarding.1_title_h',
  },
  {
    key: 'onboarding.2_title_h',
    value: 'resident_shared.onboarding.2_title_h',
  },
  {
    key: 'onboarding.3_title_h',
    value: 'resident_shared.onboarding.3_title_h',
  },
  {
    key: 'onboarding.1_desc_l',
    value: 'resident_shared.onboarding.1_desc_l',
  },
  {
    key: 'onboarding.2_desc_l',
    value: 'resident_shared.onboarding.2_desc_l',
  },
  {
    key: 'onboarding.3_desc_l',
    value: 'resident_shared.onboarding.3_desc_l',
  },
  {
    key: 'welcome.welcome_short_l',
    value: 'resident_shared.welcome.welcome_short_l',
  },
  {
    key: 'welcome.welcome_desc_short_l',
    value: 'resident_shared.welcome.welcome_desc_short_l',
  },
  {
    key: 'decline_l',
    value: 'resident_shared.general.decline',
  },
  {
    key: 'agree_l',
    value: 'resident_shared.general.agree_l',
  },
  {
    key: 'consent.terms_and_conditions_start',
    value: 'resident_shared.consent.terms_and_conditions_start',
  },
  {
    key: 'consent.terms_and_conditions_link',
    value: 'resident_shared.consent.terms_and_conditions_link',
  },
  {
    key: 'consent.terms_and_conditions_end',
    value: 'resident_shared.consent.terms_and_conditions_end',
  },
  {
    key: 'consent.terms_and_conditions_l',
    value: 'resident_shared.consent.terms_and_conditions_l',
  },
  {
    key: 'consent.terms_and_conditions_title',
    value: 'resident_shared.consent.terms_and_conditions_title',
  },
  {
    key: 'consent.data_policy_l',
    value: 'resident_shared.consent.data_policy_l',
  },
  {
    key: 'consent.data_policy_title',
    value: 'resident_shared.consent.data_policy_title',
  },
  {
    key: 'consent.data_policy_start',
    value: 'resident_shared.consent.data_policy_start',
  },
  {
    key: 'consent.data_policy_link',
    value: 'resident_shared.consent.data_policy_link',
  },
  {
    key: 'consent.data_policy_end',
    value: 'resident_shared.consent.data_policy_end',
  },
  {
    key: 'consent.document_consent_title',
    value: 'resident_shared.consent.document_consent_title',
  },
  {
    key: 'consent.document_consent_start',
    value: 'resident_shared.consent.document_consent_start',
  },
  {
    key: 'consent.document_consent_link',
    value: 'resident_shared.consent.document_consent_link',
  },
  {
    key: 'consent.document_consent_checkbox_l',
    value: 'resident_shared.consent.document_consent_checkbox_l',
  },
  {
    key: 'offline_modus_title_l',
    value: 'resident_shared.offline_modus_title_l',
  },
  {
    key: 'offline_modus_description_l',
    value: 'resident_shared.offline_modus_description_l',
  },
  {
    key: 'ticket_document.requested_desc_1_l',
    value: 'resident_shared.ticket_document.requested_desc_1_l',
  },
  {
    key: 'ticket_document.requested_desc_2_l',
    value: 'resident_shared.ticket_document.requested_desc_2_l',
  },
  {
    key: 'document.hint_h',
    value: 'resident_shared.document.hint_h',
  },
  {
    key: 'document.desc_1_l',
    value: 'resident_shared.document.desc_1_l',
  },
  {
    key: 'document.desc_2_l',
    value: 'resident_shared.document.desc_2_l',
  },
  {
    key: 'document.desc_1_m_l',
    value: 'resident_shared.document.desc_1_m_l',
  },
  {
    key: 'document.desc_2_m_l',
    value: 'resident_shared.document.desc_2_m_l',
  },
  {
    key: 'document.desc_3_m_l',
    value: 'resident_shared.document.desc_3_m_l',
  },
  {
    key: 'document.button_markall_l',
    value: 'resident_shared.document.button_markall_l',
  },
  {
    key: 'document.button_close_l',
    value: 'resident_shared.document.button_close_l',
  },
  {
    key: 'document.hint_h',
    value: 'resident_shared.document.hint_h',
  },
  {
    key: 'document.desc_1_l',
    value: 'resident_shared.document.desc_1_l',
  },
  {
    key: 'document.desc_2_l',
    value: 'resident_shared.document.desc_2_l',
  },
  {
    key: 'document.button_markall_l',
    value: 'resident_shared.document.button_markall_l',
  },
  {
    key: 'document.button_close_l',
    value: 'resident_shared.document.button_close_l',
  },
  {
    key: 'general.today_l',
    value: 'resident_shared.general.today_l',
  },
  {
    key: 'general.yesterday_l',
    value: 'resident_shared.general.yesterday_l',
  },
  {
    key: 'archive.process_l',
    value: 'resident_shared.archive.process_l',
  },
  {
    key: 'archive.ticket.description.first.line_l',
    value: 'resident_shared.archive.ticket.description.first.line_l',
  },
  {
    key: 'archive.ticket.description.second.line_l',
    value: 'resident_shared.archive.ticket.description.second.line_l',
  },
  {
    key: 'archive.ticket_a',
    value: 'resident_shared.archive.ticket_a',
  },
  // ART-19551 in-app feedback sheet. Namespaced `app_feedback.*`, NOT `feedback.*`:
  // that short-key namespace already belongs to the @immomio/feedback toast plugin
  // (see `feedback.no_mail_app_description_l` above). Kept in the shared list
  // because web (ART-19558) reuses the same copy.
  {
    key: 'feedback_prompt.title_m_h',
    value: 'resident_saas.feedback_prompt.title_m_h',
  },
  {
    key: 'feedback_prompt.subtitle_m_l',
    value: 'resident_saas.feedback_prompt.subtitle_m_l',
  },
  {
    key: 'feedback_prompt.negative_button_l',
    value: 'resident_saas.feedback_prompt.negative_button_l',
  },
  {
    key: 'feedback_prompt.positive_button_l',
    value: 'resident_saas.feedback_prompt.positive_button_l',
  },
  {
    key: 'feedback_prompt.form_title_h',
    value: 'resident_saas.feedback_prompt.form_title_h',
  },
  {
    key: 'feedback_prompt.form_subtitle_l',
    value: 'resident_saas.feedback_prompt.form_subtitle_l',
  },
  {
    key: 'feedback_prompt.category_bug_l',
    value: 'resident_saas.feedback_prompt.category_bug_l',
  },
  {
    key: 'feedback_prompt.category_idea_l',
    value: 'resident_saas.feedback_prompt.category_idea_l',
  },
  {
    key: 'feedback_prompt.category_ux_l',
    value: 'resident_saas.feedback_prompt.category_ux_l',
  },
  {
    key: 'feedback_prompt.category_other_l',
    value: 'resident_saas.feedback_prompt.category_other_l',
  },
  {
    key: 'app_feedback.comment_hint_l',
    value: 'resident_shared.app_feedback.comment_hint_l',
  },
  {
    key: 'feedback_prompt.privacy_l',
    value: 'resident_saas.feedback_prompt.privacy_l',
  },
  {
    key: 'feedback_prompt.privacy_link_l',
    value: 'resident_saas.feedback_prompt.privacy_link_l',
  },
  {
    key: 'feedback_prompt.submit_button_l',
    value: 'resident_saas.feedback_prompt.submit_button_l',
  },
  {
    key: 'feedback_prompt.thanks_title_h',
    value: 'resident_saas.feedback_prompt.thanks_title_h',
  },
  {
    key: 'feedback_prompt.thanks_subtitle_m_l',
    value: 'resident_saas.feedback_prompt.thanks_subtitle_m_l',
  },
  {
    key: 'feedback_prompt.done_button_l',
    value: 'resident_saas.feedback_prompt.done_button_l',
  },
  {
    key: 'app_feedback.character_count_l_a11y',
    value: 'resident_shared.app_feedback.character_count_l_a11y',
  },
  {
    key: 'a11y_alt_tag.app_feedback_l',
    value: 'resident_shared.a11y_alt_tag.app_feedback_l',
  },
];
